var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'dp-code-block': true,
    'dp-code-block--inline': _vm.inline,
  }},[_c('pre',{ref:"codeContainer",class:[
      'dp-code-block__inner',
      _vm.languageClass,
      {
        'is-log': _vm.isLog,
        'is-odd': _vm.isOdd,
        'is-no-copy': _vm.noCopy,
        'is-placeholder': _vm.isPlaceholder,
      }
    ]},[_c('code',{ref:"highlightElement",class:_vm.languageClass,domProps:{"innerHTML":_vm._s(_vm.parsedCode)}})]),(!_vm.noCopy)?_c('a',{class:{
      'dp-code-block__copy-to-clipboard': true,
      'dp-code-block__copy-to-clipboard--copied': _vm.copied,
    },attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.copyToClipboard.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.copyToClipboardText)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }